import type { IpCountMode } from './types';

/** AWS VPC で作成できる最小サブネット（/28） */
export const AWS_MIN_SUBNET_PREFIX = 28;

/**
 * モードに応じた使用可能 IP 数を返す
 */
export function usableIpCount(prefix: number, mode: IpCountMode): number {
  const total = 2 ** (32 - prefix);
  if (mode === 'aws') {
    if (prefix > AWS_MIN_SUBNET_PREFIX) {
      return 0;
    }
    return Math.max(0, total - 5);
  }

  if (prefix === 32) {
    return 1;
  }
  if (prefix === 31) {
    return 2;
  }
  return total - 2;
}

/**
 * AWS モードでサブネットとして許可されるプレフィックスか
 */
export function isAwsSubnetAllowed(prefix: number, mode: IpCountMode): boolean {
  return mode !== 'aws' || prefix <= AWS_MIN_SUBNET_PREFIX;
}

/**
 * AWS モードで一覧表示用に /28 より細かいサブネットか
 */
export function isAwsForbiddenSubnet(prefix: number, mode: IpCountMode): boolean {
  return mode === 'aws' && prefix > AWS_MIN_SUBNET_PREFIX;
}
